import BaseTextArea, {
  TextAreaProps as BaseTextAreaProps,
} from 'antd/lib/input/TextArea'

export interface TextAreaProps extends BaseTextAreaProps {}

export const TextArea = (props: TextAreaProps): JSX.Element => (
  <>
    <BaseTextArea {...props} />
  </>
)
